import styled from 'styled-components';
import { FormControl } from '@material-ui/core';

export const Wrapper = styled(FormControl)`
  width: 100%;

  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;
